import React, { useState, useEffect } from "react";
import "../assets/css/GroupLoanForm.css";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { fetchCustomers } from "../redux/slices/Customer/customerReportSlice";
import { toast } from "react-toastify";

export default function GroupLoanForm() {
  const { profile } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  //  console.log("profile data is ",profile);

  // ---------------- Static Data ----------------
  const [services, setServices] = useState([]);

  const [groups, setGroups] = useState([]);
  const [centers, setCenters] = useState([]);

  // const landmarks = ["Near Bank Branch", "Community Center", "Local Shop", "Other"];

  const landmarks = centers.map((center) => center.address);

  const groupnames = groups.map((group) => group.groupname);

  // ---------------- State ----------------
  const [loanType, setLoanType] = useState("");
  const [loanScheme, setLoanScheme] = useState("");
  const [availableSchemes, setAvailableSchemes] = useState([]);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedCenter, setSelectedCenter] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedGroupLeader, setSelectedGroupLeader] = useState(null);
  const [isFixedLoan, setIsFixedLoan] = useState(false);
  const [loanAmount, setLoanAmount] = useState("");
  const [loanTenure, setLoanTenure] = useState("");
  const [loanEMIAmount, setLoanEMIAmount] = useState("");
  const [loanInterest, setLoanInterest] = useState("");
  const [loanPayable, setLoanPayable] = useState("");
  const [formData, setFormData] = useState({
    loanAmount: "",
    loanTenure: "",
    loanAppliedDate: "",
  });
  const [customers, setCustomers] = useState([]);
  const [submitStatus, setSubmitStatus] = useState("");
  const [loadingg, setLoading] = useState(false);
  // const [loanScheme,setLoanScheme]=useState(null);

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const branchId = localStorage.getItem("userId");

        const params = new URLSearchParams({
          branchId,
          superAdminId: profile.superAdminId,
          // page: 1,
          limit: 1000,
        });

        const res = await axios.get(
          `https://payyug.in/api/customers?${params.toString()}`,
        );

        // console.log("costomers",res)
        setCustomers(res.data?.data || []);
      } catch (error) {
        toast.error("Failed to fetch customers");
      }
    };

    if (profile?.superAdminId) {
      fetchCustomers();
    }
  }, [profile?.superAdminId]);

  const fetchServices = async () => {
    try {
      const res = await axios.get(
        `https://payyug.in/api/premium-scheme/get-all?superAdminId=${profile?.superAdminId}`,
      );

      // console.log("services data", res);
      setServices(res?.data?.data || []);
    } catch (err) {
      console.error("Fetch Error:", err);
    }
  };

  const fetchCenters = async () => {
    try {
      const res = await axios.get(
        `https://payyug.in/api/group/centre?LoanofficerId=${profile.id}&limit=10000`,
      );

      console.log("center data", res);
      setCenters(res.data?.data || []);
    } catch (err) {
      console.error("Fetch Error:", err);
    }
  };

  const fetchGroups = async () => {
    try {
      const res = await axios.get(
        `https://payyug.in/api//groupupdate/getall?LoanofficerId=${profile.id}&CenterId=${selectedCenter.id}&limit=10000`,
      );

      console.log("groups data", res);
      setGroups(res.data?.data || []);
    } catch (err) {
      console.error("Fetch Error:", err);
    }
  };

  useEffect(() => {
    if (profile?.superAdminId) {
      fetchServices();
    }
  }, [profile?.superAdminId]);

  useEffect(() => {
    if (profile?.id) {
      fetchCenters();
    }
  }, [profile?.id]);

  useEffect(() => {
    if (profile?.id && selectedCenter?.id) {
      fetchGroups();
    }
  }, [profile?.id, selectedCenter?.id]);

  // ---------------- Effects ----------------
  useEffect(() => {
    if (loanType) {
      const schemes = services.filter(
        (s) =>
          s.serviceType === loanType && s.status.toLowerCase() === "active",
      );
      setAvailableSchemes(schemes);
    } else {
      setAvailableSchemes([]);
      setLoanScheme("");
      setSelectedService(null);
    }
  }, [loanType, services]);

  useEffect(() => {
    if (loanScheme) {
      const service = services.find((s) => s.serviceName === loanScheme);
      setSelectedService(service);
      setIsFixedLoan(service?.fixedLoanAmount > 0);
    }
  }, [loanScheme]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !selectedCenter ||
      !selectedGroup ||
      !selectedCustomer ||
      !selectedGroupLeader ||
      !selectedService
    ) {
      toast.warn("Please fill all required fields");
      return;
    }

    const payload = {
      superAdminId: profile.superAdminId,
      branchId: profile.branchId,
      centerId: selectedCenter.id,
      centerName: selectedCenter.CenterName || "",
      groupId: selectedGroup.id,
      groupName: selectedGroup.groupname,
      schemeId: selectedService.id,
      memberId: selectedCustomer.id,
      memberName: selectedCustomer.fullName,
      officerId: profile.id,
      officerName: profile.fullName,
      groupLeaderId: selectedGroupLeader.id,
      groupLeaderName: selectedGroupLeader.fullName,
      loanType: "INDIVIDUAL" || loanType,
      loanAmount: Number(formData.loanAmount),
      loanTenure: Number(formData.loanTenure),
      loanRoi: selectedService.rateOfInterest,
      loanRoiType: selectedService.roiType,
      openingDate: formData.loanAppliedDate,
      loanRecoveryFrequency: selectedService.recoveryType,
      createdBy: profile.id,
    };

    try {
      setSubmitStatus("loading");
      await axios.post(
        `https://payyug.in/api/group-loan/member/create`,
        payload,
      );
      toast.success("Group loan applied successfully");
      resetForm();
    } catch (err) {
      toast.error(err?.response?.data?.error || "Submission failed");
    } finally {
      setSubmitStatus("");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    // console.log(formData)
  };

  const handleUserIdChange = (e) => {
    const userId = e.target.value;

    // Only fill if typed ID matches
    if (userId === staticUser.id) {
      setFormData((prev) => ({
        ...prev,
        userId,
        ...staticUser,
        ...staticGuarantor,
      }));
    } else {
      // Clear the form if ID does not match
      setFormData({ userId });
    }

    // ---------- Static User Data ----------
    const staticUser = {
      id: "U123",
      fullName: "John Doe",
      mobileNumber: "9876543210",
      aadhaarNumber: "123412341234",
      panNumber: "ABCDE1234F",
      bankAccountNumber: "123456789012",
      ifsc: "IFSC0001",
      guardianName: "Jane Doe",
      address: "123 Main Street",
    };

    // ---------- Static Guarantor Data ----------
    const staticGuarantor = {
      guarantorName: "Mark Smith",
      guarantorMobile: "9123456780",
      guarantorAadhaar: "432143214321",
      guarantorPAN: "XYZAB1234C",
      guarantorRelation: "Friend",
    };

    setFormData((prev) => ({
      ...prev,
      userId,
      ...staticUser,
      ...staticGuarantor,
    }));
  };

  const handleNonZeroInput = (value, setter) => {
    const num = Number(value);
    setter(num < 0 ? 0 : num);
  };

  useEffect(() => {
    const isFixed = loanType.toLowerCase().includes("fixed");
    // console.log(selectedService?.rateOfInterest);
    if (
      !isFixed &&
      Number(loanAmount) > 0 &&
      Number(loanTenure) > 0 &&
      selectedService?.rateOfInterest
    ) {
      const principal = Number(loanAmount);
      const tenure = Number(loanTenure);
      const rateOfInterest = Number(selectedService.rateOfInterest); // Interest Rate %
      const roiType = selectedService.roiType?.toLowerCase() || "reducing"; // flat / reducing
      const recoveryFrequency =
        selectedService?.recoveryType?.toLowerCase() || "daily"; // EMI frequency
      const roiFrequency =
        selectedService?.roiFrequency?.toLowerCase() || "monthly"; // ROI frequency

      // Mapping for frequency → periods per year
      const periodsPerYearMap = {
        daily: 365,
        weekly: 52,
        "bi-weekly": 26,
        "half-quarterly": 8,
        quarterly: 4,
        monthly: 12,
        yearly: 1,
      };
      const periodsPerYear = periodsPerYearMap[recoveryFrequency] || 12;

      // ✅ Calculate periodic rate (match EMI calculator logic)
      let periodRate = 0;
      if (roiFrequency === "yearly") {
        periodRate = rateOfInterest / 100 / periodsPerYear;
      } else if (roiFrequency === "monthly") {
        switch (recoveryFrequency) {
          case "daily":
            // ✅ Simple division (same as your EMI calculator)
            periodRate = rateOfInterest / 100 / 30;
            break;
          case "weekly":
            periodRate = rateOfInterest / 100 / 4;
            break;
          case "bi-weekly":
            periodRate = rateOfInterest / 100 / 2;
            break;
          case "half-quarterly":
            periodRate = rateOfInterest / 100 / 2;
            break;
          case "quarterly":
            periodRate = ((rateOfInterest / 100) * 3) / 12;
            break;
          case "monthly":
            periodRate = rateOfInterest / 100;
            break;
          case "yearly":
            periodRate = (rateOfInterest / 100) * 12;
            break;
          default:
            periodRate = rateOfInterest / 100;
        }
      }

      let emi = 0;
      let totalInterest = 0;
      let totalPayable = 0;

      // === FLAT TYPE ===
      if (roiType === "flat") {
        totalInterest = principal * periodRate * tenure;
        totalPayable = principal + totalInterest;
        emi = totalPayable / tenure;
      }

      // === REDUCING TYPE ===
      else if (roiType === "reducing") {
        emi =
          (principal * periodRate * Math.pow(1 + periodRate, tenure)) /
          (Math.pow(1 + periodRate, tenure) - 1);
        totalPayable = emi * tenure;
        totalInterest = totalPayable - principal;
      }
      //  console.log("see this ->",emi,totalInterest,totalPayable);
      // ✅ Update values
      setLoanEMIAmount(Number(emi.toFixed(2)));
      setLoanInterest(Number(totalInterest.toFixed(2)));
      setLoanPayable(Number(totalPayable.toFixed(2)));

      // === Optional: Generate EMI Schedule for debug/display ===
      const schedule = [];
      let balance = principal;
      let currentDate = new Date();

      for (let i = 1; i <= tenure; i++) {
        const interestComponent = balance * periodRate;
        const principalComponent = emi - interestComponent;
        balance -= principalComponent;

        schedule.push({
          emiNo: i,
          emi: Number(emi.toFixed(2)),
          principal: Number(principalComponent.toFixed(2)),
          interest: Number(interestComponent.toFixed(2)),
          balance: balance > 0 ? Number(balance.toFixed(2)) : 0,
          dueDate: new Date(currentDate).toISOString().split("T")[0],
        });

        // Increment based on frequency
        switch (recoveryFrequency) {
          case "daily":
            currentDate.setDate(currentDate.getDate() + 1);
            break;
          case "weekly":
            currentDate.setDate(currentDate.getDate() + 7);
            break;
          case "bi-weekly":
            currentDate.setDate(currentDate.getDate() + 14);
            break;
          case "monthly":
            currentDate.setMonth(currentDate.getMonth() + 1);
            break;
          default:
            currentDate.setDate(currentDate.getDate() + 1);
        }
      }

      // console.table(schedule); // Optional: view full EMI breakdown in console
    } else {
      setLoanEMIAmount(0);
      setLoanInterest(0);
      setLoanPayable(0);
    }
  }, [loanAmount, loanTenure, selectedService, loanType]);

 const resetForm = () => {
    setLoanType("");
    setLoanScheme("");
    setAvailableSchemes([]);

    setSelectedService(null);

    setSelectedCenter(null);
    setSelectedGroup(null);
    setSelectedCustomer(null);
    setSelectedGroupLeader(null);

    setGroups([]);

    setIsFixedLoan(false);

    setLoanAmount("");
    setLoanTenure("");

    setLoanEMIAmount(0);
    setLoanInterest(0);
    setLoanPayable(0);

    setFormData({
        loanAmount: "",
        loanTenure: "",
        loanAppliedDate: "",
        loanDisbursalMode: "",
        groupLeaderRelation: "",
        centerName: "",
        groupName: "",
        userId: "",
    });
};

  // ---------------- Render ----------------
  return (
    <div className="group-loan-form-container">
      <h1>Group Loan Application Form</h1>
      {loadingg && <p>Loading available loan schemes...</p>}
      <form
        id="personal-loan-form"
        className="group-loan-form-section"
        onSubmit={handleSubmit}
        noValidate
      >
        {/* Loan Options & Schemes */}
        <section className="group-loan-form-inputs-section">
          <h2>Group Loan Options & Schemes</h2>
          <div className="group-loan-form-loan-options">
            <div className="group-loan-form-input-groups">
              <label htmlFor="loan-type">Group Loan Type</label>
              <select
                id="loan-type"
                name="loanType"
                value={loanType}
                onChange={(e) => setLoanType(e.target.value)}
                required
              >
                <option value="" disabled>
                  Select Group Loan Type
                </option>
                {/* {[...new Set(services.map((s) => s.serviceType))].map(
                  (type) => (
                    <option key={type} value={type}>
                      {type}
                    </option>
                  ),
                )} */}
                {services
                  .filter((s) => !s.serviceType.toLowerCase().includes("fixed"))
                  .filter(
                    (service, index, self) =>
                      index ===
                      self.findIndex(
                        (t) => t.serviceType === service.serviceType,
                      ),
                  )
                  .map((service) => (
                    <option value={service.serviceType} key={service.id}>
                      {service.serviceType}
                    </option>
                  ))}
              </select>
            </div>

            <div className="group-loan-form-input-groups">
              <label htmlFor="loan-scheme">Group Loan Scheme</label>
              <select
                id="loan-scheme"
                name="loanScheme"
                value={loanScheme}
                onChange={(e) => setLoanScheme(e.target.value)}
                disabled={!availableSchemes.length}
                required
              >
                <option value="" disabled>
                  Select Scheme
                </option>
                {availableSchemes.map((s) => (
                  <option key={s.serviceName} value={s.serviceName}>
                    {s.serviceName}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </section>

        {/* Loan Details */}
        <section className="group-loan-form-inputs-section">
          <h2>Group Loan Details</h2>
          <div className="group-loan-form-details-grid">
            <div className="group-loan-form-input-groups">
              <label>
                {isFixedLoan ? "Fixed Loan Amount" : "Minimum Loan Amount"}
              </label>
              <input
                type="number"
                value={
                  isFixedLoan
                    ? (selectedService?.fixedLoanAmount ?? "")
                    : (selectedService?.minAmount ?? "")
                }
                readOnly
              />
            </div>

            <div className="group-loan-form-input-groups">
              <label>
                {isFixedLoan ? "Fixed Loan EMI Amount" : "Maximum Loan Amount"}
              </label>
              <input
                type="number"
                value={
                  isFixedLoan
                    ? (selectedService?.fixedEmiAmount ?? "")
                    : (selectedService?.maxAmount ?? "")
                }
                readOnly
              />
            </div>

            <div className="group-loan-form-input-groups">
              <label>Group Loan Interest Rate (%)</label>
              <input
                type="number"
                value={selectedService?.rateOfInterest || ""}
                readOnly
              />
            </div>

            <div className="group-loan-form-input-groups">
              <label>ROI Frequency</label>
              <input
                type="text"
                value={selectedService?.roiFrequency || ""}
                readOnly
              />
            </div>

            {["roiType", "recoveryType", "isFixedTenure", "maxTenure"].map(
              (id) => (
                <div className="group-loan-form-input-groups" key={id}>
                  <label>
                    {
                      {
                        roiType: "ROI Type",
                        recoveryType: "Fixed Loan Frequency",
                        isFixedTenure: "Is Fixed Tenure",
                        maxTenure: `Maximum Tenure (${selectedService?.tenureType || ""})`,
                      }[id]
                    }
                  </label>
                  <input
                    type="text"
                    value={
                      id === "isFixedTenure"
                        ? selectedService?.[id]
                          ? "Yes"
                          : "No"
                        : (selectedService?.[id] ?? "")
                    }
                    readOnly
                  />
                </div>
              ),
            )}

            {!isFixedLoan &&
              [
                {
                  id: "loanAmount",
                  name: "loanAmount",
                  label: "Loan Amount",
                  value: formData.loanAmount,
                  set: setLoanAmount,
                },
                {
                  id: "loanTenure",
                  name: "loanTenure",
                  label: `Loan Tenure (${selectedService?.recoveryType || ""})`,
                  value: formData.loanTenure,
                  set: setLoanTenure,
                },
              ].map(({ id, label, value, set }) => (
                <div className="group-loan-form-input-groups" key={id}>
                  <label htmlFor={id}>{label}</label>
                  <input
                    type="number"
                    id={id}
                    name={id}
                    value={value}
                    min={1}
                    onChange={(e) => {
                      handleNonZeroInput(e.target.value, set);
                      handleChange(e);
                    }}
                  />
                </div>
              ))}

            {!isFixedLoan &&
              [
                {
                  id: "loanEMIAmount",
                  label: "Loan EMI Amount",
                  value: loanEMIAmount,
                },
                {
                  id: "loanInterest",
                  label: "Loan Interest Amount",
                  value: loanInterest,
                },
                {
                  id: "loanPayable",
                  label: "Loan Payable Amount",
                  value: loanPayable,
                },
              ].map(({ id, label, value }) => (
                <div className="group-loan-form-input-groups" key={id}>
                  <label htmlFor={id}>{label}</label>
                  <input
                    type="number"
                    id={id}
                    name={id}
                    value={value}
                    readOnly
                  />
                </div>
              ))}

            {[
              {
                id: "loanDisbursalMode",
                label: "Loan Disbursal Mode",
                options: ["Bank Transfer", "Cheque", "Cash"],
              },
            ].map(({ id, label, options }) => (
              <div className="group-loan-form-input-groups" key={id}>
                <label htmlFor={id}>{label}</label>
                <select
                  id={id}
                  name={id}
                  value={formData[id] || ""}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    Select {label}
                  </option>
                  {options.map((o) => (
                    <option key={o} value={o}>
                      {o}
                    </option>
                  ))}
                </select>
              </div>
            ))}

            <div className="group-loan-form-input-groups">
              <label htmlFor="loanAppliedDate">Group Loan Applied Date</label>
              <input
                type="date"
                required
                id="loanAppliedDate"
                name="loanAppliedDate"
                value={formData.loanAppliedDate || ""}
                onChange={handleChange}
              />
            </div>

            {/* <div className="group-loan-form-input-groups">
            <label>Group Code</label>
            <input type="text" value={selectedGroup?.groupcode|| ""} readOnly />
            </div>  */}
          </div>

          {/* <div className="group-loan-form-input-groups full-width">
              <label htmlFor="grouploan">Select Group Name</label>
              <select id="grouploan" name="grouploan" value={formData.grouploan || ""} onChange={handleChange}>
                <option value="" disabled>Group Loan Name</option>
                {groupnames.map((gn) => <option key={gn} value={gn}>{gn}</option>)}
              </select>
            </div> */}
        </section>

        <section className="group-loan-form-inputs-section">
          <div className="group-loan-form-input-groups full-width">
            <label htmlFor="centerName">Select Center Name</label>
            <select
              id="centerName"
              name="centerName"
              value={selectedCenter?.id || ""}
              //  onChange={handleChange}>
              onChange={(e) => {
                handleChange(e);
                const center = centers.find(
                  (c) => c.id === Number(e.target.value),
                );
                setSelectedCenter(center);
              }}
            >
              <option value="" disabled>
                Select Center Name
              </option>
              {centers.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.CenterName}
                </option>
              ))}
            </select>
          </div>
          <div className="group-loan-form-input-groups extra-cls full-width">
            <label htmlFor="groupName">Select Group Name</label>
            <select
              id="groupName"
              name="groupName"
              value={selectedGroup ? selectedGroup.id : ""}
              onChange={(e) => {
                const group = groups.find(
                  (g) => g.id === Number(e.target.value),
                );
                setSelectedGroup(group);
              }}
            >
              <option value="" disabled>
                Select Group Name
              </option>

              {groups.map((gn) => (
                <option key={gn.id} value={gn.id}>
                  {gn.groupname}, {gn.groupcode}
                </option>
              ))}
            </select>
          </div>
        </section>

        {/* User Details */}
        <section className="group-loan-form-inputs-section">
          <h2>Member Details</h2>
          {/* <div className="group-loan-form-input-groups">
            <label htmlFor="userId">Customer ID</label>
            <input
              type="text"
              id="userId"
              name="userId"
              placeholder="Enter User ID"
              value={formData.userId || ""}
              onChange={handleUserIdChange}
              required
              style={{marginBottom:"15px"}}
            />
          </div> */}

          <div className="group-loan-form-input-groups">
            <label htmlFor="userId">Customer Name & ID</label>
            <select
              id="userId"
              name="userId"
              value={selectedCustomer?.id || ""}
              onChange={(e) => {
                const customer = customers.find(
                  (c) => c.id === Number(e.target.value),
                );
                setSelectedCustomer(customer);
              }}
            >
              <option value=" ">select customer</option>
              {customers.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.fullName} ({c.userId})
                </option>
              ))}
            </select>
          </div>

          {/* <div className="group-loan-form-details-grid">
              {[
                // { id: "fullName", label: "Full Name" },
                { id: "mobileNumber", label: "Mobile Number" },
                { id: "aadhaarNumber", label: "Aadhaar Number" },
                { id: "panNumber", label: "PAN Number" },
                { id: "bankAccountNumber", label: "Bank Account Number" },
                { id: "ifsc", label: "IFSC" },
                { id: "guardianName", label: "Guardian Name" },
                { id: "address", label: "Address" },
              ].map(({ id, label }) => (
                <div className="group-loan-form-input-groups" key={id}>
                  <label htmlFor={id}>{label}</label>
                  <input
                    type="text"
                    id={id}
                    name={id}
                    placeholder={`Enter ${label}`}
                    value={formData[id] || ""}
                    onChange={handleChange}
                    required
                  />
                </div>
              ))}
            </div> */}

          <div className="group-loan-form-details-grid">
            {selectedCustomer && (
              <div className="group-loan-form-input-groups">
                <label>Full Name</label>
                <input
                  type="text"
                  value={selectedCustomer?.fullName || ""}
                  readOnly
                />
              </div>
            )}

            {selectedCustomer && (
              <div className="group-loan-form-input-groups">
                <label>Mobile Number</label>
                <input
                  type="text"
                  value={selectedCustomer?.mobileNumber || ""}
                  readOnly
                />
              </div>
            )}

            {selectedCustomer && (
              <div className="group-loan-form-input-groups">
                <label>Aadhaar Number</label>
                <input
                  type="text"
                  value={selectedCustomer?.aadhaarNumber || ""}
                  readOnly
                />
              </div>
            )}

            {selectedCustomer && (
              <div className="group-loan-form-input-groups">
                <label>PAN Number</label>
                <input
                  type="text"
                  value={selectedCustomer?.panNumber || ""}
                  readOnly
                />
              </div>
            )}

            {selectedCustomer && (
              <div className="group-loan-form-input-groups">
                <label>Bank Account Number </label>
                <input
                  type="text"
                  value={selectedCustomer?.bankAccount || ""}
                  readOnly
                />
              </div>
            )}

            {selectedCustomer && (
              <div className="group-loan-form-input-groups">
                <label>IFSC </label>
                <input
                  type="text"
                  value={selectedCustomer?.bankIFSC || ""}
                  readOnly
                />
              </div>
            )}

            {selectedCustomer && (
              <div className="group-loan-form-input-groups">
                <label>Guardian Name</label>
                <input
                  type="text"
                  value={selectedCustomer?.guardianName || ""}
                  readOnly
                />
              </div>
            )}

            {selectedCustomer && (
              <div className="group-loan-form-input-groups">
                <label>Address </label>
                <input
                  type="text"
                  value={selectedCustomer?.address || ""}
                  readOnly
                />
              </div>
            )}
          </div>
        </section>

        {/* Guarantor Details */}
        <section className="group-loan-form-inputs-section">
          <h2>Group Leader Details</h2>
          <div className="group-loan-form-details-grid">
            <div className="group-loan-form-input-groups">
              <label htmlFor="groupLeaderName">Group Leader Name</label>
              <select
                id="groupLeaderName"
                name="groupLeaderName"
                value={selectedGroupLeader?.id || ""}
                onChange={(e) => {
                  const customer = customers.find(
                    (c) => c.id === Number(e.target.value),
                  );
                  setSelectedGroupLeader(customer);
                }}
              >
                <option value=" ">Select Group Leader</option>
                {customers.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.fullName}
                  </option>
                ))}
              </select>
            </div>

            <div className="group-loan-form-input-groups">
              <label>Mobile Number</label>
              <input
                type="text"
                value={selectedGroupLeader?.mobileNumber || ""}
                readOnly
              />
            </div>

            <div className="group-loan-form-input-groups">
              <label>Aadhar Number</label>
              <input
                type="text"
                value={selectedGroupLeader?.aadhaarNumber || ""}
                readOnly
              />
            </div>

            <div className="group-loan-form-input-groups">
              <label>Pan Number</label>
              <input
                type="text"
                value={selectedGroupLeader?.panNumber || ""}
                readOnly
              />
            </div>

            {[
              { id: "groupLeaderRelation", label: "Relation with Applicant" },
            ].map(({ id, label }) => (
              <div className="group-loan-form-input-groups" key={id}>
                <label htmlFor={id}>{label}</label>
                <input
                  type="text"
                  id={id}
                  name={id}
                  placeholder={`Enter ${label}`}
                  value={formData[id] || ""}
                  onChange={handleChange}
                  required
                />
              </div>
            ))}
          </div>
        </section>

        <div className="group-loan-form-submit-wrapper">
          <button
            type="submit"
            className="group-loan-form-submit-btn"
            aria-label="Apply for loan"
            disabled={submitStatus === "loading"}
          >
            {submitStatus === "loading" ? "Submitting..." : "Apply"}
          </button>
        </div>
      </form>
    </div>
  );
}
